/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchTerm/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconSearch from 'DesignSystem/Svgs/TysiaIconSearch/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function SearchTerm({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/BulkActions/Content/AssignAction/Content/SearchTerm",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let userPickerSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'user_picker',
path: 'search_term',
})
let userPickerSearchTermChangeData = fromData.useDataChange({ viewPath,
context: 'user_picker',
path: 'search_term',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 marginBottom={0}
 autoFocus={true}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 borderTopLeftRadius={0}
 borderTopRightRadius={0}
 borderBottomRightRadius={0}
 borderBottomLeftRadius={0}
 borderWidth={0}
>
{childProps => (
<React.Fragment>
<TysiaIconSearch
{...childProps}
  viewPath={`${viewPath}/TysiaIconSearch`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={dtColorsNeutral400}
/>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 data="user_picker.search_term"
 value={userPickerSearchTermValueData}
 onChange={userPickerSearchTermChangeData}
 placeholder="Search"
/>
</React.Fragment>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}